import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { awardLoyalty } from "../services/reservationService";
import { useBooking } from "../context/BookingContext";
import red_box from "../assets/images/red.png"
import Loyalty from "../components/Loyalty";
import { animatePoints } from "../utils/animatePoints"; // Assuming you have this utility function

const Goodbye = () => {
  const booking = useBooking();
  console.log("booking1", booking);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const loyalty = queryParams.get("loyalty");
  const [data, setData] = useState(null);
  const [success, setSuccess] = useState(null);
  const [animatedPoints, setAnimatedPoints] = useState(0);

  useEffect(() => {
    if (loyalty === "true") {
      const reservationCode = localStorage.getItem("reservation-code");
      awardLoyalty(reservationCode)
        .then((e) => {
          console.log(e, "Loyalty points awarded successfully.");
          setData(e.booker);
          setSuccess(e.success);

          const oldPoints = booking.booker?.points || 0;
          const newPoints = e.booker?.points || 0;
          animatePoints(oldPoints, newPoints, setAnimatedPoints);
          localStorage.setItem("booker", JSON.stringify(e.booker));
        })
        .catch((error) => {
          console.error("Error awarding loyalty points:", error);
          alert(error.response?.data?.error || "An error occurred while awarding loyalty points.");
        });
    }
  }, [loyalty]);

  return (
    <div className="goodbye-page">
      <div className="goodbye-box">
        {success && data && <Loyalty data={data} animatedPoints={animatedPoints} booking={booking}/>}
        <h1>Thank You!</h1>
        <p>
          Your check-in process is complete. If you need anything else, feel free to contact our support.
        </p>
        <p className="goodbye-note">
          We wish you a pleasant stay at our hotel.
        </p>
      </div>
    </div>
  );
};

export default Goodbye;
